const validate = (editorState) => {
  const result = [];

  if (!editorState.firstname) {
    result.push({
      param: 'firstname',
      userMessage: 'Pole wymagane',
    });
  }

  if (!editorState.lastName) {
    result.push({
      param: 'lastName',
      userMessage: 'Pole wymagane',
    });
  }

  if (!editorState.email) {
    result.push({
      param: 'email',
      userMessage: 'Pole wymagane',
    });
  } else {
    // eslint-disable-next-line no-useless-escape
    const emailValidation = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const emailValidationResult = emailValidation.test(String(editorState.email).toLowerCase());

    if (!emailValidationResult) {
      result.push({
        param: 'email',
        userMessage: 'Adres e-mail jest nieprawidłowy.',
      });
    }
  }

  if (!editorState.organizationId) {
    result.push({
      param: 'organizationId',
      userMessage: 'Pole wymagane',
    });
  }

  if (!editorState.password) {
    result.push({
      param: 'password',
      userMessage: 'Pole wymagane',
    });
  }

  if (!editorState.passwordConfirm) {
    result.push({
      param: 'passwordConfirm',
      userMessage: 'Pole wymagane',
    });
  }

  if (editorState.password && editorState.passwordConfirm && editorState.password !== editorState.passwordConfirm) {
    result.push({
      param: 'passwordConfirm',
      userMessage: 'Hasła nie sa zgodne.',
    });
  }

  if (editorState.phone) {
    // eslint-disable-next-line no-useless-escape
    const phoneValidation = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/;
    const phoneValidationResult = phoneValidation.test(String(editorState.phone).toLowerCase());

    if (!phoneValidationResult) {
      result.push({
        param: 'phone',
        userMessage: 'Numer telefonu jest nieprawidłowy',
      });
    }
  }

  if (editorState.mobilePhone) {
    // eslint-disable-next-line no-useless-escape
    const mobilePhoneValidation = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/;
    const mobilePhoneValidationResult = mobilePhoneValidation.test(String(editorState.mobilePhone).toLowerCase());

    if (!mobilePhoneValidationResult) {
      result.push({
        param: 'mobilephone',
        userMessage: 'Numer telefonu jest nieprawidłowy',
      });
    }
  }

  return result.length > 0 ? result : null;
};

export default validate;
